module.exports = __webpack_public_path__ + "img/yoyolumi_hover.8d017865.png";